import { useState, useEffect, useRef, useCallback } from 'react';
import './Games.css';

export default function ReactionGame({ theme = 'default' }) {
    const [isActive, setIsActive] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [bestTime, setBestTime] = useState(null);
    const [attempts, setAttempts] = useState(0);
    const [message, setMessage] = useState('별이 빛나면 터치!');
    const [messageType, setMessageType] = useState('');
    const [waiting, setWaiting] = useState(false);
    const timeoutRef = useRef(null);

    const startRound = useCallback(() => {
        setIsActive(false);
        setWaiting(true);
        setMessage('기다리세요...');
        setMessageType('');

        const delay = 1500 + Math.random() * 2000;
        timeoutRef.current = setTimeout(() => {
            setIsActive(true);
            setStartTime(Date.now());
            setMessage('지금! 터치!');
            setWaiting(false);
        }, delay);
    }, []);

    useEffect(() => {
        startRound();
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = (e) => {
        e.preventDefault();

        if (waiting) {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setMessage('너무 빨라요! 다시~');
            setMessageType('bad');
            setTimeout(startRound, 1000);
            return;
        }

        if (isActive && startTime) {
            const time = Date.now() - startTime;
            setAttempts(prev => prev + 1);
            setIsActive(false);

            if (!bestTime || time < bestTime) {
                setBestTime(time);
            }

            if (time < 300) {
                setMessage(`⚡ ${time}ms - 번개!`);
                setMessageType('good');
            } else if (time < 500) {
                setMessage(`✨ ${time}ms - 빠름!`);
                setMessageType('good');
            } else {
                setMessage(`🌙 ${time}ms`);
                setMessageType('');
            }

            setTimeout(startRound, 1500);
        }
    };

    const themeClass = theme === 'daetong' ? 'theme-daetong' : theme === 'lighthouse' ? 'theme-lighthouse' : '';
    const msgClass = messageType === 'good' ? 'msg-good' : messageType === 'bad' ? 'msg-bad' : '';

    return (
        <div className={`game-container text-center reaction-game ${themeClass}`}>
            <div className="game-title">⚡ 반응속도 테스트</div>
            <div className="game-stats">
                <span>시도: {attempts}회</span>
                <span>최고: {bestTime ? `${bestTime}ms` : '-'}</span>
            </div>

            <div
                className="target-area"
                onClick={handleClick}
                onTouchEnd={handleClick}
            >
                <div className={`target ${isActive ? 'active' : ''}`}>
                    {isActive ? '⭐' : '🌑'}
                </div>
            </div>

            <div className={`game-message ${msgClass}`}>
                {message}
            </div>
            <div className="instruction">별이 빛나면 터치!</div>
        </div>
    );
}
